import { fromEvent } from "rxjs";

export const onWindowMessage = fromEvent<MessageEvent>(window, "message");